/** A stable torso-centered third-person orbit. Pitch changes the eye, never
 * raises the look target away from the character. Units are metres. */
export const CAMERA_FRAMING=Object.freeze({
  targetHeight:1,minimumEyeHeight:.35,initialPitch:.2,initialDistance:4,phoneInitialDistance:4.5,
  minPitch:-.65,maxPitch:1.1,minDistance:3,maxDistance:16,fov:60,
});
const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
// A tall portrait viewport needs a little more room for a torso close-up.
// The nearest zoom intentionally permits limb cropping; default views stay wider.
export function minimumCameraDistance(aspect=16/9) {
  aspect=Number.isFinite(aspect)&&aspect>0?aspect:16/9;
  return Math.min(CAMERA_FRAMING.maxDistance,CAMERA_FRAMING.minDistance*Math.max(1,.56/aspect));
}
/** View angles in the avatar's world frame, including a clamped low eye.
 * Portal camera routing rotates this same sight line into its render world.
 */
export function orbitLookAngles(pose) {
  const x=pose.desired.x-pose.target.x,y=pose.desired.y-pose.target.y,z=pose.desired.z-pose.target.z;
  return {lookYaw:Math.atan2(x,z),lookPitch:Math.atan2(y,Math.hypot(x,z))};
}
export function orbitCameraPose(feet,yaw=0,pitch=CAMERA_FRAMING.initialPitch,distance=CAMERA_FRAMING.initialDistance,aspect=16/9) {
  yaw=Number.isFinite(yaw)?yaw:0;
  pitch=clamp(Number.isFinite(pitch)?pitch:CAMERA_FRAMING.initialPitch,CAMERA_FRAMING.minPitch,CAMERA_FRAMING.maxPitch);
  distance=clamp(Number.isFinite(distance)?distance:CAMERA_FRAMING.initialDistance,minimumCameraDistance(aspect),CAMERA_FRAMING.maxDistance);
  const horizontal=distance*Math.cos(pitch),target={x:feet.x,y:feet.y+CAMERA_FRAMING.targetHeight,z:feet.z};
  const desired={
    x:feet.x+Math.sin(yaw)*horizontal,
    y:feet.y+Math.max(CAMERA_FRAMING.minimumEyeHeight,CAMERA_FRAMING.targetHeight+Math.sin(pitch)*distance),
    z:feet.z+Math.cos(yaw)*horizontal,
  };
  return {target,desired,pitch,distance};
}
